import type { FreelancerSubmitApplicationPageLocales } from '../types';

const freelancerSubmitApplicationPageLocales: FreelancerSubmitApplicationPageLocales =
  {
    clickHere: 'Click here',
    headline:
      'Thank you for your application. We will start to verify the documents. If everything goes well, we will invite you via email for a conversation to discuss your application. It could be the case that the email with the link ends up in your spam box, so keep an eye on that inbox as well!',
    instructions1:
      'You have now completed all steps of the sign up process. Did you manage to upload all necessary documents? We will begin to verify them.',
    instructions2:
      'Did you not manage to upload everything? You can upload the remaining documents in your "My Tadaah" environment.',
    instructions3:
      'Attention: if you don`t do this, we will remove your information within 30 days.',
    instructions4:
      'If all documents are in order, you will receive a link to apply for our online welcome meeting. Besides this, you will follow our online welcome training, so that you can be well prepared when you start working as a freelancer, and all your possible questions will be answered.',
    instructions5:
      'Until then, it is wise to think about a disability insurance, an accounting package, and to read about the regulations regarding the KleineOndernemersRegeling (KOR)',
    instructionsHeader: 'Welcome Meeting',
    learnMore: 'Do you want to learn more about Tadaah?',
    readInstructions: 'Prefer to read the instructions?',
    title: 'Application Submitted',
  };

export default freelancerSubmitApplicationPageLocales;
